import type { MediaItem, MediaType } from "@/types/media";

export const MEDIA_TYPES: MediaType[] = ["电影", "电视剧", "综艺"];
export const REGIONS = ["全部", "内地", "日韩", "欧美"];
export const YEARS = ["全部", "2024", "2023", "2022", "2021", "更早"];
export const SORTS = ["最新更新", "最热", "评分最高"];

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
};

export const formatDate = (date: string): string => date;

export const yearMatches = (itemYear: number, filter: string): boolean => {
  if (filter === "全部") return true;
  if (filter === "更早") return itemYear <= 2021;
  return itemYear === Number(filter);
};

export const sortItems = (items: MediaItem[], sort: string): MediaItem[] => {
  const copy = [...items];
  if (sort === "最热") {
    return copy.sort((a, b) => b.views - a.views);
  }
  if (sort === "评分最高") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort((a, b) => b.updateDate.localeCompare(a.updateDate));
};

export const filterItems = (
  items: MediaItem[],
  opts: { type?: string; region?: string; year?: string; keyword?: string }
): MediaItem[] => {
  const keyword = (opts.keyword || "").trim();
  return items.filter((item) => {
    if (opts.type && opts.type !== "全部" && item.type !== opts.type) return false;
    if (opts.region && opts.region !== "全部" && item.region !== opts.region) return false;
    if (opts.year && opts.year !== "全部" && !yearMatches(item.year, opts.year)) return false;
    if (keyword) {
      const haystack = `${item.title}${item.synopsis}${item.tags.join("")}${item.cast.join("")}`.toLowerCase();
      if (!haystack.includes(keyword.toLowerCase())) return false;
    }
    return true;
  });
};

export const getRelated = (items: MediaItem[], current: MediaItem, count = 5): MediaItem[] => {
  return items
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.type === current.type) score += 3;
      if (item.region === current.region) score += 2;
      score += item.tags.filter((tag) => current.tags.includes(tag)).length * 2;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views)
    .slice(0, count)
    .map((entry) => entry.item);
};